export default __webpack_public_path__ + "static/media/backDefaultStart.62fa8e7d.png";